import {
    Dma,
    Region,
    SegmentSelect,
    SelectionAge,
    SelectionAlcoBeverages,
    SelectionBeautyCare,
    SelectionCategory,
    SelectionClothingFashion,
    SelectionConsumerElectro,
    SelectionEatingAndDrinking,
    SelectionFinancialProducts,
    SelectionGrocery,
    SelectionHeritage,
    SelectionIncome,
    SelectionInconsistentLabel,
    SelectionInsurance,
    SelectionNonAlcogolic,
    SelectionPanelSexLabel,
    SelectionPanelSexValue,
    SelectionSports,
    SelectionSubscription,
} from 'utils';

export const SidePanelSeparateStateUS = {
    dropDownHeritage: [
        { label: SelectionHeritage.ASIAN, value: SelectionHeritage.ASIAN },
        { label: SelectionHeritage.BLACK, value: SelectionHeritage.BLACK },
        { label: SelectionHeritage.HISPANIC_ANY_RACE, value: SelectionHeritage.HISPANIC_ANY_RACE },
        { label: SelectionHeritage.MIXED_AND_ADDITIONAL, value: SelectionHeritage.MIXED_AND_OTHER },
        { label: SelectionHeritage.WHITE, value: SelectionHeritage.WHITE },
    ],
    dropDownAllCategories: [
        {
            label: SelectionCategory.ALCOGOLIC_BEVERAGES,
            value: SelectionCategory.ALCOGOLIC_BEVERAGES,
        },
        {
            label: SelectionCategory.CONSUMER_ELECTRONICS,
            value: SelectionCategory.CONSUMER_ELECTRONICS,
        },
        { label: SelectionCategory.GROCERY, value: SelectionCategory.GROCERY },
        { label: SelectionCategory.INSURANCE, value: SelectionCategory.INSURANCE },
        {
            label: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
            value: SelectionCategory.NON_ALCOHOLIC_BEVERAGES,
        },
        {
            label: SelectionCategory.SPORTS_AND_RECREATION,
            value: SelectionCategory.SPORTS_AND_RECREATION,
        },
        { label: SelectionCategory.SUBSCRIPTION, value: SelectionCategory.SUBSCRIPTION },
    ],
    dropDownAllSubcategories: {
        [SelectionCategory.ALCOGOLIC_BEVERAGES]: [
            { label: SelectionAlcoBeverages.WINE, value: SelectionAlcoBeverages.WINE },
            {
                label: SelectionInconsistentLabel.BEER_AND_ALE,
                value: SelectionAlcoBeverages.BEER_AND_ALE,
            },
            {
                label: SelectionAlcoBeverages.OTHER,
                value: SelectionAlcoBeverages.OTHER,
            },
        ],
        [SelectionCategory.CONSUMER_ELECTRONICS]: [
            {
                label: SelectionConsumerElectro.E_READERS,
                value: SelectionConsumerElectro.E_READERS,
            },
            {
                label: SelectionConsumerElectro.TELEVISIONS,
                value: SelectionConsumerElectro.TELEVISIONS,
            },
            {
                label: SelectionConsumerElectro.VIDEO_GAMES,
                value: SelectionConsumerElectro.VIDEO_GAMES,
            },
            {
                label: SelectionConsumerElectro.PERSONAL_CARE,
                value: SelectionConsumerElectro.PERSONAL_CARE,
            },
            {
                label: SelectionConsumerElectro.AUDIO_EQUIP,
                value: SelectionConsumerElectro.AUDIO_EQUIP,
            },
            {
                label: SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS,
                value: SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS,
            },
            {
                label: SelectionConsumerElectro.CELLPHONES,
                value: SelectionConsumerElectro.CELLPHONES,
            },
            {
                label: SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES,
                value: SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES,
            },
        ],
        [SelectionCategory.GROCERY]: [
            {
                label: SelectionGrocery.BAKED_GOODS,
                value: SelectionGrocery.BAKED_GOODS,
            },
            {
                label: SelectionInconsistentLabel.GENERAL_FOOD,
                value: SelectionGrocery.GENERAL_FOOD,
            },
            {
                label: SelectionGrocery.CLEANING_AND_HYGIENE,
                value: SelectionGrocery.CLEANING_AND_HYGIENE,
            },
            {
                label: SelectionGrocery.PET_FOOD,
                value: SelectionGrocery.PET_FOOD,
            },
            {
                label: SelectionInconsistentLabel.SWEET_AND_SNACKS,
                value: SelectionGrocery.SWEET_AND_SNACKS,
            },
        ],
        [SelectionCategory.INSURANCE]: [
            {
                label: SelectionInsurance.HEALTH,
                value: SelectionInsurance.HEALTH,
            },
            {
                label: SelectionInsurance.VEHICLE,
                value: SelectionInsurance.VEHICLE,
            },
            {
                label: SelectionInsurance.HOMEOWNER,
                value: SelectionInsurance.HOMEOWNER,
            },
            {
                label: SelectionInsurance.LIFE_AND_PERSONAL,
                value: SelectionInsurance.LIFE_AND_PERSONAL,
            },
        ],
        [SelectionCategory.NON_ALCOHOLIC_BEVERAGES]: [
            {
                label: SelectionNonAlcogolic.TEA,
                value: SelectionNonAlcogolic.TEA,
            },
            {
                label: SelectionNonAlcogolic.COLA,
                value: SelectionNonAlcogolic.COLA,
            },
            {
                label: SelectionNonAlcogolic.JUICE,
                value: SelectionNonAlcogolic.JUICE,
            },
            {
                label: SelectionNonAlcogolic.OTHER,
                value: SelectionNonAlcogolic.OTHER,
            },
            {
                label: SelectionNonAlcogolic.WATER,
                value: SelectionNonAlcogolic.WATER,
            },
            {
                label: SelectionNonAlcogolic.COFFEE,
                value: SelectionNonAlcogolic.COFFEE,
            },
            {
                label: SelectionNonAlcogolic.SPORTS_DRINKS,
                value: SelectionNonAlcogolic.SPORTS_DRINKS,
            },
            {
                label: SelectionNonAlcogolic.SODA,
                value: SelectionNonAlcogolic.SODA,
            },
        ],
        [SelectionCategory.SPORTS_AND_RECREATION]: [
            {
                label: SelectionSports.CLUB_MEMBERSHIPS,
                value: SelectionSports.CLUB_MEMBERSHIPS,
            },
            {
                label: SelectionSports.PARTICIPATION_FEES,
                value: SelectionSports.PARTICIPATION_FEES,
            },
            { label: SelectionSports.EVENT_TICKETS, value: SelectionSports.EVENT_TICKETS },
        ],
        [SelectionCategory.SUBSCRIPTION]: [
            {
                label: SelectionSubscription.AUDIO_STREAMING,
                value: SelectionSubscription.AUDIO_STREAMING,
            },
            {
                label: SelectionSubscription.BOOKS_AND_EBOOKS,
                value: SelectionSubscription.BOOKS_AND_EBOOKS,
            },
            {
                label: SelectionSubscription.SHOPPING_MEMBERSHIP,
                value: SelectionSubscription.SHOPPING_MEMBERSHIP,
            },
            {
                label: SelectionSubscription.VIDEO_STREAMING,
                value: SelectionSubscription.VIDEO_STREAMING,
            },
        ],
    },
    age: [
        { label: SelectionAge.GROUP_18_24, value: SelectionAge.GROUP_18_24 },
        { label: SelectionAge.GROUP_25_34, value: SelectionAge.GROUP_25_34 },
        { label: SelectionAge.GROUP_35_49, value: SelectionAge.GROUP_35_49 },
        { label: SelectionAge.GROUP_50_64, value: SelectionAge.GROUP_50_64 },
        { label: SelectionAge.GROUP_65_PLUS, value: SelectionAge.GROUP_65_PLUS },
    ],
    geoMapSelection: {
        Segment: SegmentSelect.REGION,
        REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
        DMA: Dma.NEW_YORK_NY,
    },
    income: [
        { label: SelectionIncome.GROUP_LESS_10k, value: SelectionIncome.GROUP_LESS_10k },
        { label: SelectionIncome.GROUP_10k_TO_25k, value: SelectionIncome.GROUP_10k_TO_25k },
        { label: SelectionIncome.GROUP_25k_TO_50k, value: SelectionIncome.GROUP_25k_TO_50k },
        { label: SelectionIncome.GROUP_50k_TO_75k, value: SelectionIncome.GROUP_50k_TO_75k },
        { label: SelectionIncome.GROUP_75k_TO_100k, value: SelectionIncome.GROUP_75k_TO_100k },
        { label: SelectionIncome.GROUP_ABOVE_100k, value: SelectionIncome.GROUP_ABOVE_100k },
    ],
    sex: [
        { label: SelectionPanelSexLabel.FEMALE, value: SelectionPanelSexValue.FEMALE },
        { label: SelectionPanelSexLabel.MALE, value: SelectionPanelSexValue.MALE },
    ],
};

export const SidePanelSeparateStateUK = {
    dropDownHeritage: [
        {
            label: SelectionHeritage.EAST_AND_SOUTH_ASIAN,
            value: SelectionHeritage.EAST_AND_SOUTH_ASIAN,
        },
        {
            label: SelectionHeritage.BLACK,
            value: SelectionHeritage.BLACK,
        },
        {
            label: SelectionHeritage.SOUTH_ASIAN_PAKISTANI,
            value: SelectionHeritage.SOUTH_ASIAN_PAKISTANI,
        },
        {
            label: SelectionHeritage.SOUTH_ASIAN_BANGLADESHI,
            value: SelectionHeritage.SOUTH_ASIAN_BANGLADESHI,
        },
        {
            label: SelectionHeritage.MIDDLE_EASTERN,
            value: SelectionHeritage.MIDDLE_EASTERN,
        },
        {
            label: SelectionHeritage.MIXED,
            value: SelectionHeritage.MIXED,
        },
        {
            label: SelectionHeritage.SOUTH_ASIAN_INDIAN,
            value: SelectionHeritage.SOUTH_ASIAN_INDIAN,
        },
        {
            label: SelectionHeritage.WHITE,
            value: SelectionHeritage.WHITE,
        },
    ],
    dropDownAllCategories: [
        {
            label: SelectionCategory.BEAUTY_AND_PERSONAL_CARE,
            value: SelectionCategory.BEAUTY_AND_PERSONAL_CARE,
        },
        {
            label: SelectionCategory.CLOTHING_AND_FASHION,
            value: SelectionCategory.CLOTHING_AND_FASHION,
        },
        {
            label: SelectionCategory.EATING_AND_DRINKING_OUT,
            value: SelectionCategory.EATING_AND_DRINKING_OUT,
        },
        {
            label: SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES,
            value: SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES,
        },
        {
            label: SelectionCategory.GROCERIES,
            value: SelectionCategory.GROCERIES,
        },
    ],
    dropDownAllSubcategories: {
        [SelectionCategory.GROCERIES]: [
            {
                label: SelectionGrocery.ALCOHOL_AT_HOME_WITHOUT_BRACES,
                value: SelectionGrocery.ALCOHOL_AT_HOME_WITHOUT_BRACES,
            },
            {
                label: SelectionGrocery.BABYCARE,
                value: SelectionGrocery.BABYCARE,
            },
            {
                label: SelectionGrocery.CLEANING_PRODUCTS,
                value: SelectionGrocery.CLEANING_PRODUCTS,
            },
            {
                label: SelectionGrocery.FOOD,
                value: SelectionGrocery.FOOD,
            },
            {
                label: SelectionGrocery.NEWSPAPERS_AND_MAGAZINES,
                value: SelectionGrocery.NEWSPAPERS_AND_MAGAZINES,
            },
            {
                label: SelectionGrocery.PETCARE,
                value: SelectionGrocery.PETCARE,
            },
        ],
        [SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES]: [
            {
                label: SelectionFinancialProducts.SAVINGS,
                value: SelectionFinancialProducts.SAVINGS,
            },
            {
                label: SelectionFinancialProducts.INSURANCE,
                value: SelectionFinancialProducts.INSURANCE,
            },
        ],
        [SelectionCategory.EATING_AND_DRINKING_OUT]: [
            {
                label: SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES,
                value: SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES,
            },
            {
                label: SelectionEatingAndDrinking.EATING_OUT,
                value: SelectionEatingAndDrinking.EATING_OUT,
            },
            {
                label: SelectionEatingAndDrinking.TAKEAWAY,
                value: SelectionEatingAndDrinking.TAKEAWAY,
            },
        ],
        [SelectionCategory.CLOTHING_AND_FASHION]: [
            {
                label: SelectionClothingFashion.ADULT,
                value: SelectionClothingFashion.ADULT,
            },
            {
                label: SelectionClothingFashion.CHILDREN,
                value: SelectionClothingFashion.CHILDREN,
            },
        ],
        [SelectionCategory.BEAUTY_AND_PERSONAL_CARE]: [
            {
                label: SelectionBeautyCare.HAIR_AND_COSMETICS,
                value: SelectionBeautyCare.HAIR_AND_COSMETICS,
            },
            {
                label: SelectionBeautyCare.TOILETRIES_AND_SOAP,
                value: SelectionBeautyCare.TOILETRIES_AND_SOAP,
            },
            {
                label: SelectionBeautyCare.TREATMENTS,
                value: SelectionBeautyCare.TREATMENTS,
            },
        ],
    },
    age: [
        { label: SelectionAge.GROUP_LESS_16, value: SelectionAge.GROUP_LESS_16 },
        { label: SelectionAge.GROUP_16_24, value: SelectionAge.GROUP_16_24 },
        { label: SelectionAge.GROUP_25_29, value: SelectionAge.GROUP_25_29 },
        { label: SelectionAge.GROUP_30_39, value: SelectionAge.GROUP_30_39 },
        { label: SelectionAge.GROUP_40_49, value: SelectionAge.GROUP_40_49 },
        { label: SelectionAge.GROUP_50_64, value: SelectionAge.GROUP_50_64 },
        { label: SelectionAge.GROUP_65_PLUS, value: SelectionAge.GROUP_65_PLUS },
    ],
    geoMapSelection: {
        Segment: SegmentSelect.REGION,
        REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
        DMA: Dma.NEW_YORK_NY,
    },
    income: [
        { label: SelectionIncome.GROUP_LOW_INCOME, value: SelectionIncome.GROUP_LOW_INCOME },
        { label: SelectionIncome.GROUP_MID_INCOME, value: SelectionIncome.GROUP_MID_INCOME },
        { label: SelectionIncome.GROUP_HIGH_INCOME, value: SelectionIncome.GROUP_HIGH_INCOME },
    ],
    sex: [
        { label: SelectionPanelSexLabel.FEMALE, value: SelectionPanelSexValue.FEMALE },
        { label: SelectionPanelSexLabel.MALE, value: SelectionPanelSexValue.MALE },
    ],
};
